import type { SVGProps } from 'react'
const SvgSyTumer = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle cx={12} cy={13} r={8} fillOpacity={0.24} />
		<path d="M12 7.4a.6.6 0 0 0-.6.6v5a.6.6 0 0 0 .6.6.6.6 0 0 0 .6-.6V8a.6.6 0 0 0-.6-.6m8.354-2.046a.5.5 0 0 0-.707-.708zm-1.5 1.5 1.5-1.5-.707-.708-1.5 1.5zM12 2.4a7 7 0 0 0-1.33.114c-.399.076-.705.132-1.012.418a.6.6 0 0 0-.03.847.6.6 0 0 0 .849.03c-.079.073.12-.058.42-.116.3-.057.696-.093 1.103-.093s.804.036 1.104.093c.3.058.498.189.42.116a.6.6 0 0 0 .847-.03.6.6 0 0 0-.03-.847c-.306-.286-.612-.342-1.01-.418A7 7 0 0 0 12 2.4" />
	</svg>
)
export default SvgSyTumer
